export enum SiteHeaderType {
  Application,
  Search,
  View,
  Hide,
}
